import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { socialLoginPaylaod, User } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class socialLoginService {


  constructor(
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  userSocialLogin(payload: socialLoginPaylaod, queryString: string): Observable<User> {
    return this.http
      .post<{ data: User }>(`${environment.base_url}user/socialLogin?${queryString}`, payload)
      .pipe(map(res => res.data));
  }
}
